import { TypeOfSearch } from '@/types';

export class ProductsSearch {
    public keyword!: string;
    public searchType!: TypeOfSearch;
    public searchInHistorical!: boolean;
    public pageNumber!: number;
    public pageSize!: number;
    public sortField!: string;
    public sortDirection!: string;

    constructor() {
        this.keyword = '';
        this.pageNumber = 1;
        this.pageSize = 20;
        this.sortField = 'name',
        this.sortDirection = 'asc';
        this.searchInHistorical = false;
        this.searchType = TypeOfSearch.StartsWith;
    }
}
